var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.0127C20.5467 6.0127 21.014 6.20734 21.4033 6.59668C21.7927 6.98602 21.9873 7.45334 21.9873 8V21.9697L18.0088 17.9912L18.0127 17.9873H8C7.45334 17.9873 6.98602 17.7927 6.59668 17.4033C6.20734 17.014 6.0127 16.5467 6.0127 16V15.0127H17C17.5533 15.0127 18.0269 14.8149 18.4209 14.4209C18.8149 14.0269 19.0127 13.5533 19.0127 13V6.0127H20ZM4 2.0127H15C15.4782 2.0127 15.8962 2.16109 16.2539 2.45898L16.4033 2.59668C16.7927 2.98602 16.9873 3.45334 16.9873 4V11C16.9873 11.5467 16.7927 12.014 16.4033 12.4033C16.014 12.7927 15.5467 12.9873 15 12.9873H6V12.9824L2.0127 16.9697V4C2.0127 3.5218 2.16109 3.10385 2.45898 2.74609L2.59668 2.59668C2.98602 2.20734 3.45334 2.0127 4 2.0127ZM3.9873 12.2051L5.17969 11.0127H15.0127V3.9873H3.9873V12.2051Z",
    fill: "#909090",
    stroke: "#909090",
    strokeWidth: 0.025
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.b69c5233cdb50d640cd3d9351c1df322.svg";
export { ForwardRef as ReactComponent };